export const apiUrl = process.env.VUE_APP_ROOT_API;
export const ablyApiKey = process.env.VUE_APP_ABLY_API_KEY;

export default { apiUrl };
